import {
	Button,
	DefineDocumentUploadButton,
	DownloadPersonalInfoButton,
	SelectDocumentInfo,
	TableWithActions,
	UploadButton,
} from '@/components';
import { TableTypes } from '@/constant';
import React, { memo, useCallback } from 'react';

import { Divider } from 'antd';

import DefineFileUploadModal from '../define-file-upload/define-file-upload.view';
import { validationSchema } from './define-document-area.config';
import { useLogic } from './define-document-area.logic';
import { IDefineDocumentAreaProps } from './define-document-area.type';

const DefineDocumentArea: React.FC<IDefineDocumentAreaProps> = ({
	showIssuanceApplication = true,
	showCheckbox = true,
	showRegistration = true,
	showDownloadRight = false,
	showActionsTop = true,
	showApplicant = false,
	pageType,
	refTableId,
	zipFileName,
	optionsApplicant,
	franchiseMappingOptions,
	applicantMappingOptions,
	isForeign = false,
}) => {
	const {
		columns,
		rowSelection,
		handleDownloadDocumentsBeforeOpen,
		handleDownloadDocuments,
		handlePageSizeChange,
		page,
		totalCount,
		handlePageChange,
		showConfirmDelete,
		setPage,
		onClickUpload,
		reloadDefineDocumentAreaList,
		filterRef,
		loading,
		t,
		handleUploadClick,
		handleCloseUploadModal,
		isUploadModalVisible,
		fileList,
	} = useLogic({
		pageType,
		refTableId,
		zipFileName,
		isForeign,
	});

	const ActionsLeftComponent = useCallback(() => {
		return (
			<>
				<Divider type="vertical" className="mx-0 h-4" />
				<DownloadPersonalInfoButton
					asChild
					onBeforeOpen={handleDownloadDocumentsBeforeOpen}
					onDownload={handleDownloadDocuments}
				>
					<Button name="download">{t('download-documents')}</Button>
				</DownloadPersonalInfoButton>
			</>
		);
	}, [handleDownloadDocuments]);

	const renderActionsRight = useCallback(() => {
		return (
			<>
				{showDownloadRight && (
					<DownloadPersonalInfoButton
						asChild
						onBeforeOpen={handleDownloadDocumentsBeforeOpen}
						onDownload={handleDownloadDocuments}
					>
						<Button name="download">{t('download-documents')}</Button>
					</DownloadPersonalInfoButton>
				)}
				<UploadButton
					onClickUpload={onClickUpload}
					label={t('upload-file-document')}
				/>
				{showRegistration && (
					<DefineDocumentUploadButton
						refTableId={refTableId}
						refTableName={pageType}
						callback={reloadDefineDocumentAreaList}
					/>
				)}
			</>
		);
	}, [
		showDownloadRight,
		showRegistration,
		handleDownloadDocuments,
		handleUploadClick,
		refTableId,
		pageType,
		reloadDefineDocumentAreaList,
	]);

	return (
		<div>
			<TableWithActions
				titleInDetail={t('title')}
				actionsTop={
					<SelectDocumentInfo
						pageType={pageType}
						showActionsTop={showActionsTop}
						showApplicant={showApplicant}
						showCheckbox={showCheckbox}
						showIssuanceApplication={showIssuanceApplication}
						refTableId={refTableId}
						page={page}
						setPage={setPage}
						optionsApplicant={optionsApplicant}
						ref={filterRef}
						listFranchiseMapping={franchiseMappingOptions || []}
						listApplicantMapping={applicantMappingOptions || []}
						isDocumentArea={true}
					/>
				}
				actionsLeft={!showDownloadRight ? <ActionsLeftComponent /> : undefined}
				actionsRight={renderActionsRight}
				columns={columns}
				editable
				rowKey="id"
				rowSelection={rowSelection}
				onDelete={showConfirmDelete}
				defaultPageSize={page.pageSize}
				onPageSizeChange={handlePageSizeChange}
				pagination={{
					defaultPageSize: page.pageSize,
					pageSize: page.pageSize,
					current: page.current,
					total: totalCount,
				}}
				onPageChange={handlePageChange}
				tableType={TableTypes.DEFINE_DOCUMENT_AREA}
				validationSchema={validationSchema}
				isSearching={filterRef?.current?.isSearching}
				loading={loading}
			/>

			{isUploadModalVisible && (
				<DefineFileUploadModal
					visible={isUploadModalVisible}
					onClose={handleCloseUploadModal}
					files={fileList}
					pageType={pageType}
					refTableId={refTableId}
				/>
			)}
		</div>
	);
};

export default memo(DefineDocumentArea);
